import { defineStore } from 'pinia';
import { pcCardAssetWithdrawInfo } from '@/api/wallet';

function createFallbackList() {
  return [
    {
      symbol: 'USDT',
      logo: '',
      balanceNormal: '0',
      chains: [
        {
          symbolType: 'BEP20',
          feeRate: '0.01',
          feeMin: '1'
        }
      ]
    }
  ];
}

export function findWithdrawCoin(list = [], asset = {}) {
  const symbol = String(asset?.symbol || asset?.coin || '').trim().toUpperCase();
  const contractAddress = String(asset?.contractAddress || '').trim().toLowerCase();

  return list.find((item) => {
    const itemContractAddress = String(item?.contractAddress || '').trim().toLowerCase();
    if (contractAddress && itemContractAddress) {
      return contractAddress === itemContractAddress;
    }

    const itemSymbol = String(item?.symbol || item?.coin || '').trim().toUpperCase();
    return !!symbol && symbol === itemSymbol;
  }) || null;
}

export const useWalletWithdrawStore = defineStore('wallet-withdraw', {
  state: () => ({
    loading: false,
    list: [],
    selectedCoinIndex: 0
  }),
  getters: {
    selectedCoin(state) {
      return state.list[state.selectedCoinIndex] || state.list[0] || null;
    }
  },
  actions: {
    reset() {
      this.loading = false;
      this.list = createFallbackList();
      this.selectedCoinIndex = 0;
    },
    setSelectedCoinIndex(index) {
      const nextIndex = Number(index);
      if (Number.isNaN(nextIndex) || nextIndex < 0 || nextIndex >= this.list.length) {
        return;
      }
      this.selectedCoinIndex = nextIndex;
    },
    async fetchWithdrawInfo({ address, reset = false } = {}) {
      if (reset || !this.list.length) {
        this.reset();
      }

      this.loading = true;
      try {
        const result = await pcCardAssetWithdrawInfo({ address: address || null });
        const rows = Array.isArray(result?.list) ? result.list : [];
        if (rows.length) {
          this.list = rows;
          if (this.selectedCoinIndex >= rows.length) {
            this.selectedCoinIndex = 0;
          }
        }
        return this.list;
      } catch (error) {
        if (!this.list.length) {
          this.reset();
        }
        throw error;
      } finally {
        this.loading = false;
      }
    }
  }
});
